import axios from '@/libs/axios'

export default {
  namespaced: true,

  state: {
    customer: null,
    customers: [],
    customersTotal: 0,
    orderCreatedCustomer: null,
  },

  getters: {
    customer(state) {
      return state.customer
    },
    customers(state) {
      return state.customers
    },
    customersTotal(state) {
      return state.customersTotal
    },
  },

  mutations: {
    SET_CUSTOMER(state, value) {
      state.customer = value
    },
    SET_CUSTOMERS(state, value) {
      state.customers = value
    },
    SET_CUSTOMERS_TOTAL(state, value) {
      state.customersTotal = Number(value) || 0
    },
    UPDATE_CUSTOMER(state, changedCustomer) {
      const index = state.customers.findIndex(customer => customer.id === changedCustomer.id)
      if (index === -1) {
        return
      }
      Object.assign(state.customers[index], changedCustomer)
    },
    ADD_CUSTOMER(state, data) {
      state.customers.unshift(data);
      state.customersTotal += 1
    },
    SET_ORDER_CREATED_CUSTOMER(state, customer) {
      state.orderCreatedCustomer = customer;
    },
  },

  actions: {
    async loadCustomer({ commit }, customerId) {
      try {
        const response = await axios.get(`api/customer/${customerId}`);
        commit('SET_CUSTOMER', response.data);
        return response.data;
      } catch (error) {
        console.error('Error loading customer:', error);
        throw error;
      }
    },
    loadCustomers({ commit }, filters = {}) {
      const params = {}
      if (filters.keyword) {
        params.keyword = filters.keyword
      }
      if (filters.page) {
        params.page = filters.page
      }
      if (filters.per_page) {
        params.per_page = filters.per_page
      }

      return axios.get('api/customers', { params }).then(response => {
        const data = response.data.data || []
        const total = Number(response.data.meta?.total ?? data.length)
        commit('SET_CUSTOMERS', data)
        commit('SET_CUSTOMERS_TOTAL', total)
        return { data, total }
      })
    },
    loadRepeatCustomers({ commit }, filters = {}) {
      const params = {}
      if (filters.keyword) {
        params.keyword = filters.keyword
      }
      if (filters.page) {
        params.page = filters.page
      }
      if (filters.per_page) {
        params.per_page = filters.per_page
      }

      return axios.get('api/customers-repeat', { params }).then(response => {
        const data = response.data.data || []
        const total = Number(response.data.meta?.total ?? data.length)
        commit('SET_CUSTOMERS', data)
        commit('SET_CUSTOMERS_TOTAL', total)
        return { data, total }
      })
    },
    async recovery({ commit }, data) {
      await axios.post('api/send-password-recovery', data);
    },
    updateCustomer({ commit }, payload) {
      const formData = payload?.formData || payload
      const id = formData instanceof FormData
        ? formData.get('id')
        : payload.id

      // Do not set Content-Type manually — axios must add the multipart boundary.
      const request = formData instanceof FormData
        ? axios.post(`api/customers/${id}`, formData)
        : axios.put(`api/customers/${id}`, payload)

      return request.then((response) => {
        const customer = response.data?.data ?? response.data
        commit('UPDATE_CUSTOMER', customer)
        return customer
      })
    },
    addCustomer({ commit }, payload) {
      const formData = payload?.formData || payload
      const request = formData instanceof FormData
        ? axios.post('api/customers', formData)
        : axios.post('api/customers', payload)

      return request.then((response) => {
        const customer = response.data?.data ?? response.data
        commit('ADD_CUSTOMER', customer)
        return {
          ...customer,
          email_sent: response.data?.email_sent,
        }
      })
    },
    async searchCustomer({ commit }, keyword) {

      return await axios.post(`api/customers/search`,
          {
            keyword: keyword
          }
      ).then((response) => {
        return response.data;
      })
    },
  }
}
